import FormTextInput from './FormTextInput';
import { FormTextInputProps } from './types';

export type { FormTextInputProps };
export default FormTextInput;
